import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { AuthService } from "../auth/auth.service";
import { AlertError } from "../error-handler";
import { ProjectService } from "../project/project.service";

@Injectable({
    providedIn: "root"
})
export class OrganigramaService {
    constructor(
        private http: HttpClient,
        private authSvc: AuthService,
        private projectSvc: ProjectService
    ) {}

    getAllDepartaments(): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/departaments";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getAllDepartamentsResp(): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/departaments/asignados";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getAllTiendasResp(): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/tiendas/asignados";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getJob(parentId): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/puestos/" + parentId;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getTarjetaUsuario(usuario): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/getTarjeta/" + usuario;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getTarjetaGrupo(grupo): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/getTarjetaGrupo/" + grupo;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getTarjetaUsuarioLeroy(usuario): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/getTarjetaLeroy/" + usuario;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getAllDelegations(tipo: string): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                }),
                params: null
            };
            options.params = new HttpParams();
            options.params = options.params.set("tipo", tipo);

            const url = environment.urlDomain + "/api/v1/organigrama/delegations";
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getPuestosFromDepartamento(id): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/puestos/" + id;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getAllProjects(id): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/proyectos/" + id;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getDepartamento(depa, id): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/departamento/" + depa + "/" + id;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getTiendaLeroy(tienda: number): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/organigramasLeroy/" + tienda;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getDelegacion(dele, id): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/unidadfuncional/" + dele + "/" + id;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getProyecto(pro, id): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/proyecto/" + pro + "/" + id;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getAllOrgFromUser(personId: number): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/organigramasFromUser/" + personId;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }

    getPersonasFromGrupo(idGrupo: number): Observable<any> {
        return new Observable<any>((observer) => {
            const accessToken = this.authSvc.getAccessToken();

            const options = {
                headers: new HttpHeaders({
                    Authentication: "Bearer " + accessToken,
                    "Content-Type": "application/json; charset=utf-8"
                })
            };

            const url = environment.urlDomain + "/api/v1/organigrama/getPersonasFromGrupo/" + idGrupo;
            this.http.get(url, options).subscribe(
                (response: any) => {
                    observer.next(response);
                },
                (err) => {
                    AlertError.showError(err);
                }
            );
        });
    }
}
